import { themeColors } from './theme-colors.const'

export const CHART_TOOLTIP = {
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  textStyle: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 12,
    fontFamily: 'Montserrat'
  },
}

export const LINE_CHART_DEFAULT_OPTION = {
  color: themeColors['point-color'],
  gradientColor: themeColors['chart-gradient-color'],
}

export const BAR_CHART_DEFAULT_OPTION = {
  color: themeColors['point-color'],
}

export const PIE_CHART_DEFAULT_OPTION = {
  color: themeColors['point-color'],
  borderColor: themeColors.background,
}
